import { useQuery } from "@apollo/client";
import { FormSelect } from "components/Forms/FormSelect";
import { gql } from "generated-graphql";
import {
  CredentialInputForValidation,
  CredentialKind,
} from "generated-graphql/graphql";
import { Control } from "react-hook-form";

const GET_PORTALS = gql(`
  query GetPortals($search: String, $sort: [SortModel!]) {
    portalSearch(search: $search, sort: $sort) {
      items {
        id
        jurisdiction
        description
      }
    }
  }
`);

type CredentialPortalPickerProps = {
  control: Control<CredentialInputForValidation>;
  facilityState?: string | null;
  kind?: CredentialKind | null;
  disabled?: boolean;
};

export const CredentialPortalPicker = ({
  kind,
  disabled,
  control,
}: CredentialPortalPickerProps) => {
  const { data } = useQuery(GET_PORTALS, {
    variables: {
      search: kind ? `kind:${kind}` : undefined,
      sort: [{ field: "description", sort: "asc" }],
    },
  });

  const portals = data?.portalSearch?.items ?? [];

  return (
    <FormSelect
      sx={{ mt: 0.5 }}
      disabled={disabled}
      name="portalId"
      label="Portal"
      selectItems={portals.map((p) => ({
        display: p.description ?? p.jurisdiction,
        value: p.id,
      }))}
      control={control}
      rules={{ required: true }}
    />
  );
};
